// import React, { useState, useEffect } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import axios from "axios";

// // Custom Previous Arrow
// const PrevArrow = ({ onClick }) => {
//   return (
//     <div className="banner-arrow banner-prev" onClick={onClick}>
//       ❮
//     </div>
//   );
// };

// // Custom Next Arrow
// const NextArrow = ({ onClick }) => {
//   return (
//     <div className="banner-arrow banner-next" onClick={onClick}>
//       ❯
//     </div>
//   );
// };

// const Banner = () => {
//   const [bannerData, setBannerData] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       const response = await axios.get(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_banner"
//       );
//       setBannerData(response.data.data);
//     };

//     fetchData();
//   }, []);

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 2900,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 4000,
//     arrows: true,
//     prevArrow: <PrevArrow />,
//     nextArrow: <NextArrow />,
//   };

//   return (

//       // DYNAMIC CODE FOR BANNER 
//     <div className="banner">
//       <Slider {...settings}>
//         {bannerData.map((banner, index) => (
//           <div key={index}>
//             {/* <img
//               src={`https://cyberathon.com/multivendor/${banner.banner_image}`}
//               alt={banner.banner_heading || "Banner"}
//               className="banner-img"
//             /> */}
//              <img
//               src={'./img/1766055277_banner_main.png'}
//               className="banner-img"
//             />
            
//           </div>
          
//         ))}
//       </Slider>
//     </div>

//     //     <div className="banner">
//     //   <img
//     //     src={"/img/1766055277_banner_main.png"}
//     //     alt="Banner"
//     //     className="banner-img"
//     //   />
//     // </div>

//   );
// };

// export default Banner;











import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import "./Banner.css";

// ─── Custom Arrows ───────────────────────────────────────────
const PrevArrow = ({ onClick }) => (
  <div className="banner-arrow banner-prev" onClick={onClick}>
    ❮
  </div>
);

const NextArrow = ({ onClick }) => (
  <div className="banner-arrow banner-next" onClick={onClick}>
    ❯
  </div>
);

// ─── Slider Settings ─────────────────────────────────────────
const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 2900,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows: true,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
};

// ─── Banner Component ─────────────────────────────────────────
const Banner = () => {
  const [bannerData, setBannerData] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_banner"
        );
        setBannerData(response.data.data);
      } catch (error) {
        console.error("Failed to fetch banners:", error);
        // Fallback: show at least one slide even if API fails
        setBannerData([{ banner_heading: "Banner" }]);
      }
    };

    fetchBanners();
  }, []);

  return (
    <div className="banner">
      <Slider {...sliderSettings}>
        {bannerData.map((banner, index) => (
          <div key={index} className="banner-slide-wrapper">

            {/* Banner Image */}
            <img
              src={`https://cyberathon.com/multivendor/${banner.banner_image}`}
              alt={banner.banner_heading || "Banner"}
              className="banner-img"
            />

            {/* Overlay Text — Left Side */}
            <div className="banner-overlay-content">
              <h1 className="banner-title">
                Curated Picks for <br></br>Your Lifestyle
              </h1>
              <p className="banner-subtext">
                Not everything. Only what matters.
              </p>
              <a href="#" className="banner-cta">
                Explore Now
              </a>
            </div>

          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Banner;